/**
 * @generated SignedSource<<b0636699c164a29b15dcd785e228ee02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AclItem = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type PlaylistAccessAclMutation$variables = {
  acl: ReadonlyArray<AclItem>;
  id: string;
};
export type PlaylistAccessAclMutation$data = {
  readonly updatePlaylist: {
    readonly acl: ReadonlyArray<{
      readonly actions: ReadonlyArray<string>;
      readonly info: {
        readonly assignableActions: ReadonlyArray<string> | null | undefined;
        readonly implies: ReadonlyArray<string> | null | undefined;
        readonly label: { default: string } & Record<string, string | undefined>;
        readonly safeActions: ReadonlyArray<string>;
      } | null | undefined;
      readonly role: string;
    }>;
  };
};
export type PlaylistAccessAclMutation = {
  response: PlaylistAccessAclMutation$data;
  variables: PlaylistAccessAclMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "acl",
    "variableName": "acl"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AclItemWithInfo",
  "kind": "LinkedField",
  "name": "acl",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "implies",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "safeActions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignableActions",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PlaylistAccessAclMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AuthorizedPlaylist",
        "kind": "LinkedField",
        "name": "updatePlaylist",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PlaylistAccessAclMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AuthorizedPlaylist",
        "kind": "LinkedField",
        "name": "updatePlaylist",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ba3e02a18f834cd14254e7e3fd725ec5",
    "id": null,
    "metadata": {},
    "name": "PlaylistAccessAclMutation",
    "operationKind": "mutation",
    "text": "mutation PlaylistAccessAclMutation(\n  $id: ID!\n  $acl: [AclItem!]!\n) {\n  updatePlaylist(id: $id, acl: $acl) {\n    acl {\n      role\n      actions\n      info {\n        label\n        implies\n        safeActions\n        assignableActions\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "60b443208f2c35a12242eed7773cb094";

export default node;
